import { buildPlaybookFeedbackUrl } from "@repo/app-types/helpers/playbookFeedbackUrl";
import type { PlaybookFeedbackReferenceWrapper } from "@repo/ui/structuredContent/playbookFeedbackReferenceContext";

/**
 * Links structured content playbook feedback references in Admin to the item
 * in the playbook's feedback tab, in a new tab. Supplied via
 * `PlaybookFeedbackReferenceProvider`.
 */
export const PlaybookFeedbackReferenceLinkAdapter: PlaybookFeedbackReferenceWrapper =
  (props) => {
    const { reference, className, children } = props;
    return (
      <a
        href={buildPlaybookFeedbackUrl(reference)}
        target="_blank"
        rel="noopener noreferrer"
        className={className}
      >
        {children}
      </a>
    );
  };
